import Box from '@mui/material/Box'
import config from '../../config'
import styles from './EnvironmentBanner.module.scss'

const EnvironmentBanner = () => {
  const environment = config.environment

  if (!environment || environment.toLowerCase() === 'production') {
    return null
  }

  return (
    <Box className={styles.wrapper}>
      <Box className={styles.label}>{environment}</Box>
    </Box>
  )
}

export default EnvironmentBanner
